// ./multigame/frontend/src/js/loader.js
// Hardcoded base path for Monorepo setup
// Ensure this matches your Vercel folder structure
const PREFIX = '/multigame/html/';

const partials = [
    'ui_overlays.html',
    'editor_ui.html',
    'map_ui.html',
    'asset_ui.html',
    'mobile_ui.html'
];

async function loadUI() {
    const app = document.getElementById('app');
    if (!app) {
        console.error("[LOADER] Critical: #app div not found!");
        return;
    }
    
    console.log("[LOADER] Fetching partials from:", PREFIX);

    const promises = partials.map(file => {
        const url = PREFIX + file;
        return fetch(url).then(res => {
            if (!res.ok) {
                console.error(`[LOADER] 404 Not Found: ${url}`);
                throw new Error(`Failed to load ${url}`);
            }
            return res.text();
        });
    });
    
    try {
        const htmls = await Promise.all(promises);
        
        htmls.forEach(html => {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            while(temp.firstChild) {
                app.appendChild(temp.firstChild);
            }
        });

        console.log("[LOADER] UI Injected successfully.");
        
        // Boot App AFTER HTML is there
        import('../app.js');

    } catch (e) {
        console.error("[LOADER] Failed:", e);
        document.body.innerHTML = `<h1 style='color:red; padding:20px; background:white;'>UI Load Failed.<br><small>${e.message}</small></h1>`;
    }
}

loadUI();